export class ConvertFromToPixel {
    constructor ({width, height, dpi, from, to, roundPx}) {
        this.width = width;
        this.height = height;
        this.dpi = dpi || 1;
        this.from = from || 'px';
        this.roundPx = roundPx || false;
        this.to = to;
    }

    toPx() {
        const {width, height, from, dpi} = this;
        let multiply = 1;

        switch (from) {
            case 'cm': 
                multiply = dpi / 2.54; // dpi / (1 cm -> inch)
                break;
            case 'inch':
                multiply = dpi; // number of dots per inch
                break;
            default:
                break;
        }

        let res = {
            w: width * multiply,
            h: height * multiply
        }

        return {
            width: this.roundPx === true ? Math.round(res.w) : res.w,
            height: this.roundPx === true ? Math.round(res.h) : res.h
        }
    }

    fromPx() {
        const {width, height, to, dpi} = this;
        let divide = 1;
        let multiply = 1;

        switch (to) {
            case 'cm': 
                divide = dpi;
                multiply = 2.54; // (cm -> inch)

                break;
            case 'inch':
                divide = dpi; // number of dots per inch
                break;
            default:
                break;
        }

        return {
            width: width * multiply / divide,
            height: height * multiply / divide
        }
    }

    calculate () {
        const {width, height, from, to} = this;

        if(to === 'px') {
            return this.toPx();
        } else if(from === 'px') {
            return this.fromPx();   
        }

        return {
            width: width,
            height: height
        }
    }
}



// WEBPACK FOOTER //
// ./src/helper/calculator/convertFromToPixel.js